import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed, theme } from "shared/lib/styles";

export const Container = styled.div`
  position: absolute;
  z-index: 1000;

  inline-size: 298px;
  padding: 14px;

  color: #ffffff;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 24px;
  text-align: start;

  border: 1px solid #001246;
  border-radius: 4px;

  background-color: #001246;

  opacity: 0.95;
  &::before {
    position: absolute;
    inset-block-start: -11px;
    inset-inline-end: 17px;
    content: "";

    display: block;

    inline-size: 20px;
    block-size: 20px;

    background: #001246;

    transform: rotate(45deg);
    ${theme.breakpoints.up("desktop")} {
      inset-block-start: 17px;
      inset-inline-start: -11px;
    }
  }
  span {
    font-weight: bold;
  }
`;

export const StyledBaseLink = styled(BaseLink)`
  color: #ffffff;
  text-decoration: underline;
`;
